module.exports = __webpack_public_path__ + "components/page-header/static/surf-badge--dark-ff41309888ccdb92e84b93624b9857d1.svg";